import { browserUtil } from '../common'
import React, { useEffect } from 'react'
import { localStorageUtil } from 'src/util/local-storage-util'

export const SignOutScreen = (): React.ReactElement => {
  browserUtil.redirect('/auth/logout')

  useEffect(() => {
    localStorageUtil.clearAllCachedData()
  }, [])

  return <></>
}
